import { mapBarOrPieMetricsData, mapTrend } from './mappers';
import type { IPieChartSourceData, ILineChartSourceData } from '@/pages/intelligence/components/Chart/types';
import type {
  ITopChartsCompaniesRank,
  ITopChartsCompaniesTrend,
  ITopChartsTypeOfCompanies,
} from '@/pages/intelligence/pages/TopCharts/Companies/components/CompaniesCore/types';

export const generateBarOrPieData = (
  topChartsType: ITopChartsTypeOfCompanies,
  list: ITopChartsCompaniesRank[],
): IPieChartSourceData[] => {
  if (!Array.isArray(list)) return [];
  return list.filter((item) => item?.app_id && item?.name).map((item) => mapBarOrPieMetricsData(topChartsType, item));
};

export const generateLineData = (
  topChartsType: ITopChartsTypeOfCompanies,
  list: ITopChartsCompaniesTrend[],
): ILineChartSourceData[] => {
  if (!Array.isArray(list)) return [];
  return list.filter((item) => item?.id && item?.name).map((item) => mapTrend(topChartsType, item));
};
